import { delay } from 'redux-saga/effects';

export const ANSWER_SUBMIT_ATTEMPTS = 4;

export const ANSWER_SUBMIT_BASE_DELAY_MS = 700;

export const REPLAYABLE_STATUSES = [502, 503, 504];

export const isReplayable = (error) => {
    if (error?.response) return REPLAYABLE_STATUSES.includes(error.response.status);
    if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') return true;
    return Boolean(error?.request);
};

export const startReplayable = (send) => {
    let started = send();
    started?.catch?.(() => {});
    return () => {
        const inFlight = started ?? send();
        started = null;
        return inFlight;
    };
};

export function* submitAnswerWithRetry(send, label) {
    let lastError;

    for (let attempt = 1; attempt <= ANSWER_SUBMIT_ATTEMPTS; attempt += 1) {
        try {
            const res = yield send();
            if (attempt > 1) {
                console.info(`[${label}] submitted on attempt ${attempt} of ${ANSWER_SUBMIT_ATTEMPTS}`);
            }
            return res;
        } catch (error) {
            lastError = error;

            if (!isReplayable(error) || attempt === ANSWER_SUBMIT_ATTEMPTS) {
                throw error;
            }

            const wait = ANSWER_SUBMIT_BASE_DELAY_MS * 2 ** (attempt - 1);
            console.warn(
                `[${label}] attempt ${attempt} of ${ANSWER_SUBMIT_ATTEMPTS} failed ` +
                    `(${error?.response?.status ?? error?.code ?? 'no response'}); ` +
                    `retrying in ${wait}ms`
            );
            yield delay(wait);
        }
    }

    throw lastError;
}
